import { type FC } from 'react';
import ReactPlayer from 'react-player';

import Flex from 'quarks/Flex';
import Paragraph from 'quarks/Paragraph';
import type { BasicProps } from 'quarks/interpolations/basic';

import Modal from 'molecules/Modal/Modal';

import ComponentButton from 'components/Button/ComponentButton';

import type { ContentfulComponentVideo } from 'graphqlTypes';

interface VideoPopupProps
  extends BasicProps,
    Omit<ContentfulComponentVideo, 'children' | 'contentful_id' | 'id' | 'internal' | 'node_locale'> {
  open: boolean;
  onClose: () => void;
}

const VideoPopup: FC<VideoPopupProps> = ({ open, onClose, __typename, ...props }) => (
  <Modal
    open={open}
    onClose={onClose}
    paddingY={32}
    maxWidth="85vw"
    width="100%"
    marginX="auto"
    lg={{ maxWidth: '75vw' }}
    css={`
      [role='button'] {
        top: 25px;
        right: -30px;
      }

      @media (max-width: 768px) {
        div[role='button'] > svg {
          color: white !important;
        }
      }
    `}
  >
    <ReactPlayer url={props.videoUrl} playing={true} width="100%" height="42.2vw" controls={true} />
    {(props.popupHeading || props.popupBody) && (
      <Flex
        flexDirection="column"
        paddingX={8}
        paddingTop={16}
        gap="1rem"
        width="100%"
        md={{ flexDirection: 'row', justifyContent: 'space-between', gap: '3rem' }}
        lg={{ paddingX: 40 }}
      >
        <Flex flexDirection="column">
          {props.popupHeading && (
            <Paragraph
              textColor="white"
              fontSize="textLg"
              fontWeight="semiBold"
              marginBottom={16}
              md={{ marginBottom: 24 }}
            >
              {props.popupHeading}
            </Paragraph>
          )}
          {props.popupBody?.popupBody && (
            <Paragraph textColor="white" fontSize="textXs">
              {props.popupBody?.popupBody}
            </Paragraph>
          )}
        </Flex>
        {props.popupCta && (
          <Flex>
            <ComponentButton {...props.popupCta} width="max-content" fontSize="textXs" />
          </Flex>
        )}
      </Flex>
    )}
  </Modal>
);

export default VideoPopup;
